import React from 'react'
import { Button } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'

function RenderBtn({children, to }) {
     const location = useLocation();

  return (
          <Button
            color="inherit"
            component={NavLink}
            to={to}
            selected={location.pathname === to}
            sx={{
                ':hover': {
                    // bgcolor: '#ebebeb ',
                    background:'none'
                  },
                  '&.active': {
                    borderBottom:' 2px solid',
                    borderBottomColor:' #008FD7',
                   

                  },
                   width:100,
                 borderRadius: '0px',
                // opacity: 1,
                color:'#001D2B',
                 padding:'10px',
                textTransform:'none',
                fontWeight:600,
                margin:'0 3px'

            }}
            >
            {children}
          </Button>
  )
}

export default RenderBtn